import React, { useState } from 'react'
import BrightcovePlayer from '../../brightcovePlayer/BrightcovePlayer.jsx'
import { BRIGHTCOVE_VIDEO_PLAYER_ID } from '../../../utility'
import { IconText, Link2 } from '../../'
import PropTypes from 'prop-types'
import './blogArticleVideos.css'
import DOMPurify from 'dompurify'

function BlogArticleVideos({ videoList }) {
  function removeDuplicatesVideos() {
    return videoList.reduce((accumulator, video) => {
      const existingVideo = accumulator.find(
        (item) => item.videoId == video.videoId
      )
      if (!existingVideo) {
        accumulator = [...accumulator, video]
      }
      return accumulator
    }, [])
  }
  const uniqueVideoList = removeDuplicatesVideos()
  const [videos, setVideos] = useState(uniqueVideoList)

  const onAction = (event) => {
    const actionType = event?.type
    const isPlaying = actionType == 'play' ? true : false
    const selectedVideoId = event.target.getAttribute('data-video-id')
    const updatedVideos = getUpdatedVideos(selectedVideoId, isPlaying)
    setVideos(updatedVideos)
  }
  function getUpdatedVideos(selectedVideoId, isPlaying = false) {
    const updatedVideos = videos.map((item) => {
      if (item.videoId === selectedVideoId) {
        return { ...item, isPlaying }
      }
      return item
    })
    return updatedVideos
  }
  function renderVideoList() {
    return (
      <div className="BlogArticleVideo u-marginBottom6gu">
        <div className="u-posRelative u-sizeConstrained">
          <div>
            {videos.map((video) => {
              const { videoId = '', isPlaying } = video
              return (
                <div key={videoId} className="u-flex u-flexCol">
                  <div
                    className={`u-posRelative u-decoBorderLight u-decoBorderResetBottom ${
                      isPlaying ? 'expanded-wrapper' : 'collapsed-wrapper'
                    }`}
                  >
                    <div className="u-flex u-flexWrap">
                      <div
                        className={`outerContainer u-posRelative u-sizeFull ${
                          isPlaying
                            ? 'expanded-wrapper u-sizeConstrained u-sm-sizeConstrainedFlush'
                            : 'collapsed-wrapper'
                        }`}
                      >
                        {renderVideoView(video)}
                        {renderContent(video)}
                      </div>
                    </div>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    )
  }

  function renderSingleVideo() {
    const video = videos[0]
    return (
      <div className="u-posRelative u-marginBottom6gu expanded-wrapper">
        <div className="u-flex u-flexWrap">
          <div className="outerContainer u-sizeFull u-sizeConstrained u-sizeConstrainedNarrow">
            {renderVideoView(video, true)}
            {renderContent(video, true)}
          </div>
        </div>
      </div>
    )
  }

  function renderVideoView(video, isSingleVideo = false) {
    const {
      title = '',
      videoId = '',
      isPlaying,
      brightcoveAccount = '',
    } = video
    const brightcoveAccountId = brightcoveAccount.split(':')[1].trim()
    const playerId = brightcoveAccount.includes('Ameriprise Brightcove account')
      ? BRIGHTCOVE_VIDEO_PLAYER_ID
      : 'qAEHsSC1j9'
    return (
      <div
        key={videoId}
        className={`blog-video ${
          isSingleVideo ? '' : 'u-posAbsolute'
        } u-sm-posRelative u-sm-sizeFull ${
          isSingleVideo
            ? 'expanded-video u-size12of12 u-md-size1of2'
            : isPlaying
              ? 'expanded-video u-size8of12 u-md-size1of2'
              : 'collapsed-video u-size4of12 blog-video-padding'
        }`}
      >
        <div className="u-flex u-flexJustifyEnd video-container">
          <div className="brightcove-react-player-loader">
            <BrightcovePlayer
              accountId={
                brightcoveAccountId ?? window.BRIGHTCOVE_PLAYER_ACCOUNT_ID
              }
              videoId={videoId}
              playerId={playerId}
              onVideoPlayCallback={onAction}
              onVideoPauseCallback={onAction}
              attrs={{
                'data-analytics':
                  title
                    ?.replaceAll('.', '')
                    .replaceAll(' ', '-')
                    .toLowerCase() + '-video',
              }}
            />
          </div>
        </div>
      </div>
    )
  }

  function renderContent(video, isSingleVideo = false) {
    const {
      content = '',
      title = '',
      watchTime = '',
      isPlaying,
      link: { asButton = false, text: linkText = '', link: linkList = [] } = {},
    } = video
    const linkHref = linkList[0]?.linkHref
    const noData = !content && !title && !watchTime && !linkHref
    if (noData) {
      return <></>
    }
    return (
      <div
        className={`Content u-flex u-flexCol  u-flexAlignItemsStart ${
          isPlaying ? 'u-paddingVert0gu' : 'u-sm-paddingVert4gu'
        }`}
      >
        <div className="u-flex u-sizeFull u-flexJustifyStart">
          <div
            className={`u-flex u-flexCol u-flexAlignItemsStart u-sm-sizeFull ${
              isSingleVideo ? 'u-paddingVert4gu' : 'u-paddingVert8gu'
            } u-sm-paddingVert0 u-md-paddingVert4gu u-paddingRight4gu u-sm-paddingRight0 ${
              isSingleVideo
                ? 'u-size12of12'
                : isPlaying
                  ? 'u-size4of12 u-md-size1of2'
                  : 'u-size8of12'
            }`}
          >
            {title ? (
              <h3 className="u-textColorBrand u-textBold">{title}</h3>
            ) : null}
            {content ? (
              <div
                className="Content"
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(content),
                }}
              ></div>
            ) : null}
            {watchTime ? (
              <div className="u-flex u-flexAlignItemsCenter u-marginTop4gu">
                <div className="icon u-flex u-flexAlignItemsEnd">
                  <IconText
                    icon={'Time'}
                    text={watchTime}
                    className="u-flexAlignItemsCenter"
                  />
                </div>
              </div>
            ) : null}
            {linkHref ? (
              <Link2
                url={linkHref}
                text={linkText}
                arrow={asButton ? '' : 'brand'}
                className={`${
                  asButton
                    ? 'Button Button--secondary u-textColorBrandLight u-decoBorderBrandLight'
                    : 'Link u-posRelative hover-underline-animation'
                } u-paddingTop2gu`}
                textClasses={`u-textSecondary u-textKernLoose`}
              />
            ) : null}
          </div>
        </div>
      </div>
    )
  }

  return <>{videos.length > 1 ? renderVideoList() : renderSingleVideo()}</>
}

BlogArticleVideos.propTypes = {
  videoList: PropTypes.array.isRequired,
}

export { BlogArticleVideos }
